import { render, staticRenderFns } from "./material-category-category.vue?vue&type=template&id=2f3899c5&scoped=true"
import script from "./material-category-category.vue?vue&type=script&lang=js"
export * from "./material-category-category.vue?vue&type=script&lang=js"
import style0 from "./material-category-category.vue?vue&type=style&index=0&id=2f3899c5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3899c5",
  null
  
)

export default component.exports